import {Box, Text, useColorModeValue} from '@chakra-ui/react';

function FallbackPage(props) {
    const textColor = useColorModeValue('blue.800', 'white');

    return (

        <Box>
            <Text
                fontSize="40px"
                fontStyle="normal"
                fontWeight="700"
                color={textColor}
                mb="12px"
            >
                You don&#39;t have permission to access any pages available for your role.
            </Text>

        </Box>

    );
}

export default FallbackPage;
